.riskCategoryContainer { 
    display: flex;
    align-items: flex-end;
}

.riskCategoryName {
    width: 50%;
}